module.exports = __webpack_public_path__ + "img/frame2.dfee0928.png";